import { mainApi, cacheApi } from "config/api";
import { getClientFor } from "infrastructure/http";

export const addRelease = async (release: { releaseId: string; name: string }) => await getClientFor(mainApi.name).post(`/releases`, release);
export const refreshMessageCache = async () => await getClientFor(cacheApi.name).get(`/v1/cache/refresh`);
